import { FC } from 'react';
import Script from 'next/script';

const ReadBanner: FC = () => {
  return (
    <>
      <Script strategy='lazyOnload'>
        {`
          window.yaContextCb.push(()=>{
          Ya.Context.AdvManager.render({
          renderTo: 'yandex_rtb_R-A-745625-6',
          blockId: 'R-A-745625-6'})})
        `}
      </Script>
      <Script strategy='lazyOnload'>
        {`
          window.yaContextCb.push(()=>{
          Ya.Context.AdvManager.render({
          renderTo: 'yandex_rtb_R-A-745625-7',
          blockId: 'R-A-745625-7'})})
        `}
      </Script>
    </>
  );
};

export default ReadBanner;
